<template lang="pug"></template>

<script>
export default {
    name: 'BotaoTerritorioSucursales',
    componentOptions: {
        title: 'DashboardSubEmpresa',
        actions: [
            [
                {
                    name: 'Territorio',
                    showView: false,
                    action: 'abrirDashboard',
                    route: 'TerritorioSucursales',
                    nameTranslationKey: 'mensagens.menuLateral.territorio'
                }
            ]
        ]
    },

    methods: {
        abrirDashboard() {
            if (this.$route.name !== 'TerritorioSucursales') {
                this.$router.push({
                    name: 'TerritorioSucursales'
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
